import actionCreatorFactory from "typescript-fsa";
import { BootstrapAuthData } from "../common/actions/Auth";

export interface BootstrapData {
  router: {
    path: string;
    queryString: string | undefined;
    query: { [key: string]: any };
  };
  page: string;
  body: any;
  auth: BootstrapAuthData;
}

export const actionCreatorFactoryForBootstrap = () => actionCreatorFactory("bootstrap");



// WEBPACK FOOTER //
// ./frontend/src/lib/bootstrap.ts